module.exports = {
	"START_AUTOSCROLL": "Ξεκίνημα αυτόματου scroll σελίδας",
	"STOP_AUTOSCROLL": "Σταμάτημα αυτόματου scroll σελίδας",
	"CHANGE_MATCH": "Αλλαγή αγώνα",
	"MATCH_ID": "ID αγώνα",
	"MATCH_RESULTS": "Αποτελέσματα αγώνων",
	"MOBILE_SCORING_ROUND_1_OPEN": "Επιτρέπεται σκορ από κινητό (Γύρος 1)",
	"MOBILE_SCORING_ROUND_2_OPEN": "Επιτρέπεται σκορ από κινητό (Γύρος 2)",
	"ADD_SHOTS_VISUAL": "Παρακολούθηση στόχων",
	"TARGET_ONE": "Στόχος Νο1",
	"TARGET_TWO": "Στόχος Νο2",
	"DIRECTION": "Κατέυθυνση",
	"NO": "Οχι",
	"YES": "Ναι",
	"FRONT": "Εμπρός",
	"BACK": "Πίσω",
	"CREATED_AT": "Δημιουργήθηκε",
	"UPDATED_AT": "Ενημερώθηκε",
	"DELETE_TRAINING_ENTRY": "Διαγραφή εισόδου προπονητηρίου?",
	"AVAILABLE": "Διαθέσιμο για χρήση",
	"NOT_AVAILABLE": "Μή διαθέσιμο",
	"SELECT_PLAYER": "Επιλέξτε αθλητή",
	"SELECT_TARGET": "Επιλέξτε στόχο",
	"SELECT_LEAGUE": "Επιλέξτε κατηγορία",
	"SELECT_LEAGUES": "Επιλέξτε κατηγορίες",
	"SELECT_MATCH": "Επιλέξτε αγώνα",
	"SELECT_TEAM": "Επιλέξτε σύλλογο",
	"SELECT_SEX": "Επιλέξτε φύλλο",
	"SELECT_PAYMENT": "Επιλέξτε είδος πληρωμής",
	"PLAYERS_PER_TARGET": "Αθλητές άνα στόχο",
	"MATCH_ENTRIES_LIMIT": "Όριο συμμετοχών",
	"UPDATE_PLAYER_LEAGUE": "Αλλαγή κατηγορίας",
	"REGISTRATIONS": "Συμμετοχές",
	"REGISTRATION_OPEN": "Δηλώσεις συμμετοχών ανοιχτές",
	"REGISTRATION_CLOSED": "Δηλώσεις συμμετοχών κλειστές",
	"MOVE_MATCH": "Μεταφορά σε αγώνα",
	"NEW_MATCH": "Αγώνας για μεταφορά",
	"LEAGUES_LIST": "Συμμετοχές Άνα κατηγορία",
	"PLAYERS_LIST": "Συμμετοχές Αλφαβητικά",
	"TEAMS_LIST": "Συμμετοχές Άνα Σύλλογο",
	"TARGETS_LIST": "Συμμετοχές Άνα Στόχο",
	"QUALIFICATION": "Κατάταξη",
	"QR": "QR",
	"MEDALS": "Μετάλλια",
	"PRINTS": "Εκτυπώσεις",
	"DOWNLOAD": "Κατέβασμα",
	"ELIMINATION_ROUNDS": "Ολυμπιακοί Γύροι",
	"ELIMINATION_INDIVIDUAL": "Ατομικά",
	"ELIMINATION_TEAM": "Ομαδικά",
	"ELIMINATION_MIXED_TEAM": "Μικτά Ομαδικά",
	"ELIMINATION_PARTICIPANTS": "Συμμετοχές",
	"SELECT_ELIMINATION_PARTICIPANTS": "Επιλέξτε συμμετοχές",
	"NEXT_ROUND": "Επόμενος Γύρος",
	"PRINT_PDF": "Εκτύπωση",
	"STARTING_ROUND": "Αρχή",
	"CURRENT_ROUND": "Κατάσταση",
	"ADD_ELIMINATION_LEAGUE": "Δημιουργία Κατηγορίας",
	"ELIMINATION_INDIVIDUAL_LEAGUES": "Κατηγορίες Ατομικών Ολυμπιακών Γύρων",
	"ELIMINATION_TEAM_LEAGUES": "Κατηγορίες Ομαδικών Ολυμπιακών Γύρων",
	"ELIMINATION_MIXED_TEAM_LEAGUES": "Κατηγορίες Μικτών Ομαδικών Ολυμπιακών Γύρων",
	"CREATE": "Δημιουργία",
	"PLAYER_ONE": "Αθλητής Νο1",
	"PLAYER_TWO": "Αθλητής Νο2",
	"PLAYER_THREE": "Αθλητής Νο3",
	"UPDATE_TEAM_LEAGUE_PLAYERS": "Ενημέρωση αθλητών ομάδας",
	"FINALIZE_ROUND_ONE": "Ενημέρωση γύρου 1",
	"FINALIZE_ROUND_TWO": "Ενημέρωση γύρου 2",
	"FINALIZE_MATCH": "Ενημέρωση αγώνα",
	"TARGETS_WITH_EMPTY_SHOTS": "Στόχοι που λείπουν βολές",
	"MALE": "Άντρας",
	"FEMALE": "Γυναίκα",
	"PLAYER_PAYMENTS_FULFILLMENT": "Οικονομικές οφειλές",
	"REMOVE": "Αφαίρεση",
	"ADD": "Προσθήκη",
	"ADD_PLAYER_TO_MATCH": "Προσθήκη αθλητή στον αγώνα",
	"CURRENT_PLAYERS": "Τρέχουσες Συμμετοχές",
	"MATCH_ELIGIBILITY_EXPLAIN_TEXT": "Δεν μπορείτε να δηλώσετε τον αθλητή στον αγώνα για τους εξής λόγους:",
	"PRINT_REGISTRATIONS_PDF": "Εκτύπωση PDF τρέχουσας δήλωσης",
	"REGISTRATION_IS_CLOSED": "Οι δηλώσεις συμμετοχών έχουν κλείσει.",
	"ADD_SHOTS": "Προσθήκη Βολών",
	"ROUND_ONE": "Γύρος 1ος",
	"ROUND_TWO": "Γύρος 2ος",
	"CLEAR_ROUND": "Καθαρισμός Βολών Γύρου",
	"FINAl_SCORES_ROW": "Τελικά Σκορ",
	"ADD_SHOTS_INDIVIDUAL": "Προσθήκη Βολών Ατομικών",
	"REQUIRED_BY_TEAM": "Συνδρομή Συλλόγου",
	"REQUIRED_BY_PLAYER": "Συνδρομή Αθλητή",
	"ADD_NEW_PAYMENT": "Προσθήκη νέου είδος πληρωμής",
	"ADD_TEAM_PAYMENT": "Προσθήκη πληρωμής ομάδας",
	"ADD_PLAYER_PAYMENT": "Προσθήκη πληρωμής αθλητή",
	"PAYMENT": "Είδος Πληρωμής",
	"AMOUNT": "Ποσό",
	"STAFF": "Προσωπικό",
	"EDIT_STAFF": "Επεξεργασία Προσωπικού",
	"STAFF_PROFILE": "Προφίλ Προσωπικού",
	"SELECT_ROUND": "Επιλέξτα Γύρο",
	"FINAL_SHOT": "S.O.",
	"ADD_SHOTS_TEAM": "Προσθήκη Βολών Ομαδικών",
	"ADD_SHOTS_MIXED_TEAM": "Προσθήκη Βολών Μικτών Ομαδικών",
	"MATCH_NAME": "Όνομα Αγώνας",
	"MATCH_SORT_NAME": "Συντομογραφία",
	"MATCH_HOST": "Διοργανωτής",
	"MATCH_JUDGE": "Κριτές (Παλιό)",
	"MATCH_REPRESENTER": "Εκπρόσωπος",
	"MATCH_COMMITTEE": "Αγωνόδικος Επιτροπή",
	"MATCH_OFFICIAL": "Επίσημος Αγώνας",
	"MATCH_LOCATION": "Τοποθεσία",
	"MATCH_CUP": "Κύπελλο",
	"MATCH_CHAMPIONSHIP": "Πρωτάθλημα",
	"MATCH_TYPE": "Είδος Αγώνα",
	"MATCH_LEAGUES": "Κατηγορίες Αγώνα",
	"LEAGUE_CAT": "Είδος",
	"EXIT_GAME": "Έξοδος",
	"MATCH_REGISTRATION_START": "Έναρξη Συμμετοχών",
	"MATCH_REGISTRATION_END": "Λήξη Συμμετοχών",
	"EDIT_MATCH": "Επεξεργασία Αγώνα",
	"LEAGUE_TYPE": "Είδος",
	"LEAGUE_SEX": "Φύλλο",
	"LEAGUE_ELIMINATIONS_ELIGIBILITY": "Ολυμπιακοί Γύροι",
	"DISTANCE_INDOOR": "Απόσταση Εσ. Χώρου",
	"DISTANCE_OUTDOOR": "Απόσταση Εξ. Χώρου",
	"LEAGUE_SORT_NAME": "Συντομογραφία",
	"LEAGUE_CODE": "Κωδικός",
	"LEAGUE_ORDER": "Σειρά",
	"EDIT_LEAGUE": "Επεξεργασία Κατηγορίας",
	"SCHOOL": "Σχολική",
	"AGE": "Ηλικία ( ίσο ή μεγαλύτερο )",
	"CREATE_LEAGUE": "Δημιουργία Κατηγορίας",
	"CREATE_MATCH": "Δημιουργία Αγώνα",
	"PICK": "Επιλογή",
	"DOWNLOAD_CARD": "Κάρτα",
	"DOWNLOAD_TRAINING_CARD": "Κάρτα Προπονητηρίου",
	"TRAINING_ENTRIES": "Εισόδοι Προπονητηρίου",
	"ENDED": "Τελείωσε",
	"PAUSED": "Σε παύση",
	"PAUSE": "Παύση",
	"UNPAUSE": "Συνέχεια",
	"END": "Λήξη",
	"START": "Εκκίνηση",
	"START_ENTRY": "Εξαναγκαστική Εκκίνηση",
	"PAUSE_TRAINING_ENTRY": "Θέλετε σίγουρα να κάνετε παύση της εισόδου?",
	"END_TRAINING_ENTRY": "Θέλετε σίγουρα να κάνετε λήξετε την είσοδο?",
	"UNPAUSE_TRAINING_ENTRY": "Θέλετε σίγουρα να κάνετε συνεχίσετε την είσοδο?",
	"ADD_TRAINING_ENTRIES": "Προσθήκη εισόδων προπονητηρίου",
	"START_TRAINING_ENTRY": "Θέλετε να κάνετε χρήση της εισόδου?",
	"TRAINING_CENTER": "Προπονητήριο",
	"OAKA_TRAINING_CENTER": "Προπονητήριο OAKA",
	"CURRENT_ACTIVE_INSIDE": "Εντός προπονητηρίου",
	"INFORMATION": "Πληροφορίες",
	"SORT_NAME": "Συντομογραφία",
	"POSTAL_CODE": "Τ.Κ.",
	"VAT": "Α.Φ.Μ.",
	"OFFICIAL": "Official",
	"IMAGE": "Εικόνα",
	"SELECT_FILE": "Επιλέξτε εικόνα",
	"MAP_LOCATION": "Τοποθεσία",
	"CREATE_TEAM": "Δημιουργία Ομάδας",
	"SELECT_YEAR": "Επιλέξτε χρονιά",
	"SELECT_STATE": "Επιλέξτε νομό",
	"SELECT_COUNTY": "Επιλέξτε δήμο",
	"SELECT_REGION": "Επιλέξτε χώρα",
	"GO_TO_PROFILE": "Προφίλ",
	"MATCHES": "Αγώνες",
	"REPORTS": "Reports",
	"PAYMENTS": "Πληρωμές",
	"PAYMENT_ITEMS": "Είδη Πληρωμών",
	"TEAM_PAYMENTS": "Πληρωμές Συλλόγων",
	"MENU": "Μενού",
	"DASHBOARD": "Πίνακας Ελέγχου",
	"LOGOUT": "Έξοδος",
	"SELECT": "Επιλογή",
	"ACTIONS": "Επιλογές",
	"ABOUT": "Σχετικά",
	"TEAM_PROFILE": "Προφίλ Ομάδας",
	"FILTERS": "Φίλτρα",
	"TEAM_PAYMENTS_LIST": "Κινήσεις Συλλόγων",
	"PLAYER_PAYMENTS_LIST": "Κινήσεις Αθλητών",
	"DATE_FROM": "Ημερομηνία από",
	"DATE_TO": "Ημερομηνία εώς",
	"EDIT_TEAM_PAYMENT": "Επεξεργασία Κίνησης Συλλόγου",
	"EDIT_PLAYER_PAYMENT": "Επεξεργασία Κίνησης Αθλητή",
	"PRINT_RESULTS": "Εκτύπωση Κινήσεων",
	"SELECT_NATIONALITY": "Επιλέξτε Εθνικότητα",
	"SELECT_CITIZENSHIP": "Επιλέξτε Υπήκοότητα",
	"BIRTH_DATE": "Ημερομηνία Γέννησης",
	"ACTIVE": "Ενεργός",
	"FATHER": "Όνομα Πατρός",
	"MOTHER": "Όνομα Μητρός",
	"PLAYER_PROFILE": "Προφίλ Αθλητή",
	"PLAYER_PAYMENT_REPORT": "Καρτέλα Πληρωμών Αθλητή",
	"TRANSFER_PLAYER": "Μεταγραφή Αθλητή",
	"SELECT_NEW_TEAM": "Επιλέξτα νέο σύλλογο",
	"NEW_TRANSFER_PLAYER": "Νέα Μεταγραφή Αθλητή",
	"EDIT_TRANSFER_PLAYER": "Επεξεργασία Μεταγραφής Αθλητή",
	"OLD_TEAM": "Παλιός Σύλλογος",
	"NEW_TEAM": "Νέος Σύλλογος",
	"OLD_HEALTH_SORT": "Παλιό Δ.Υ.",
	"NEW_HEALTH_SORT": "Νέο Δ.Υ.",
	"ERROR": "Κάτι πήγε στραβά...",
	"ENTER": "Είσοδος",
	"CONFIRM": "Επιβεβαίωση",
	"CONFIRM_DELETE_TEAM": "Είστε σίγουρος θέλετε να διαγράψετε αυτό τον σύλλογο?",
	"CONFIRM_DELETE_PLAYER": "Είστε σίγουρος θέλετε να διαγράψετε αυτό τον αθλητή?",
	"CONFIRM_DELETE_LEAGUE": "Είστε σίγουρος θέλετε να διαγράψετε αυτή την κατηγορία?",
	"CONFIRM_DELETE_MATCH": "Είστε σίγουρος θέλετε να διαγράψετε αυτό τον αγώνα?",
	"CONFIRM_DELETE_PAYMENT": "Είστε σίγουρος θέλετε να διαγράψετε αυτό το είδος πληρωμής?",
	"CONFIRM_CLEAR_TARGETS": "Είστε σίγουρος θέλετε να καθαρίσετε τους στόχους?",
	"CONFIRM_REMOVE_LEAGUE_FROM_MATCH": "Είστε σίγουρος θέλετε να αφαιρέσετε την κατηγορία από τον αγώνα?",
	"CONFIRM_MOVE_LEAGUES": "Είστε σίγουρος θέλετε να μεταφέρετε τις κατηγορίες?",
	"CONFIRM_DELETE_ELIMINATION_MATCH": "Είστε σίγουρος θέλετε να διαγράψετε τον ολυμπιακό γύρο?",
	"CONFIRM_REMOVE_PLAYER_FROM_MATCH": "Είστε σίγουρος θέλετε να αφαιρέσετε τον αθλητή από τον αγώνα?",
	"CHANGE_TEAM_PASSWORD": "Αλλαγή Κωδικού Συλλόγου",
	"CHANGE_PASSWORD": "Αλλαγή Κωδικού",
	"NEW_PASSWORD": "Κωδικός",
	"NEW_PASSWORD_CONFIRMATION": "Κωδικός (Επιβεβαίωση)",
	"AUTHORIZATION_KEY": "Κλειδί Ασφαλείας",
	"ROLES": "Ρόλοι",
	"DISPLAY_NAME": "Όνομα",
	"DESCRIPTION": "Περιγραφή",
	"EDIT_ROLE": "Επεξεργασία Ρόλου",
	"CREATE_ROLE": "Δημιουργία Ρόλου",
	"SELECT_PERMISSIONS": "Επιλέξτε Δικαιώματα",
	"USERS": "Χρήστες",
	"EDIT_USER": "Επεξεργασία Χρήστη",
	"CREATE_USER": "Δημιουργία Χρήστη",
	"SELECT_ROLE": "Επιλέξτε Ρόλο",
	"ROLE": "Ρόλος",
	"CHANGE_USER_PASSWORD": "Αλλαγή Κωδικού Χρήστη",
	"WELCOME_TO": "Καλως ήρθες στο ",
	"ADD_REMOVE_PLAYERS": "Προσθήκη / Αφαίρεση Αθλητών",
	"CREATE_PLAYER": "Προσθήκη Αθλητή",
	"LOAD_ALL_PLAYERS": "Όλοι οι αθλητές",
	"SIGN_IN": "Είσοδος",
	"USER": "Χρήστης",
	"YOUR_EMAIL": "Το email σας",
	"RETURN_TO": "Επιστροφή στην ",
	"FORGOT_YOUR_PASSWORD": "Ξεχάσατε τον κωδικό σας?",
	"FORGOT_PASSWORD_ENTER_EMAIL": "Βάλτε το email σας και θα σας στείλουμε οδηγίες να αλλάξετε τον κωδικό σας.",
	"RECOVER_SUCCESS": "Εάν βρεθεί λογαριασμός με το συγκεκριμένο email θα σταλεί μήνυμα με οδηγίες.",
	"RESET_PASSWORD": "Νέος Κωδικός",
	"LOAD_FINANCIAL_OK_PLAYERS": "Ενεργοί Αθλητές ( Χωρίς Οικονομικές Εκκρεμότητες )",
	"AD_BLOCK_MESSAGE": "Παρακαλούμε για την σωστή λειτουργία απενεργοποιήστε το adBlocker για την ιστοσελίδα αυτή.",
	"CONTRACT_DATE": "Ημερομηνία λήξης σύμβασης",
	"HAS_COACH": "Διαθέτει προπονητή?",
	"TARGETS_BOARDS": "Πινάκια Στόχων",
	"JUDGES": "Κριτές",
	"EDIT_JUDGE": "Επεξεργασία Κριτή",
	"CREATE_JUDGE": "Δημιουργία Κριτή",
	"JUDGE_PROFILE": "Προφιλ Κριτή",
	"CONFIRM_DELETE_JUDGE": "Είστε σίγουρος θέλετε να διαγράψετε αυτό τον κριτή?",
	"SELECT_JUDGES": "Επιλέξτε κριτές",
	"COACHES": "Προπονητές",
	"EDIT_COACH": "Επεξεργασία Προνοπητή",
	"CREATE_COACH": "Δημιουργία Προνοπητή",
	"COACH_PROFILE": "Προφιλ Προνοπητή",
	"CONFIRM_DELETE_COACH": "Είστε σίγουρος θέλετε να διαγράψετε αυτό τον προπονητή?",
	"TRAINERS": "Εκπαιδευτές",
	"EDIT_TRAINER": "Επεξεργασία Εκπαιδευτή",
	"CREATE_TRAINER": "Δημιουργία Εκπαιδευτή",
	"TRAINER_PROFILE": "Προφιλ Εκπαιδευτή",
	"CONFIRM_DELETE_TRAINER": "Είστε σίγουρος θέλετε να διαγράψετε αυτό τον εκπαιδευτή?",
	"PRINT_GAME_PDF": "Εκτύπωση PDF Κατάταξης εώς τώρα",
	"PRINT_GAME_PDF_AFTER_GAME": "Εκτύπωση PDF Κατάταξης",
	"PRINT_GAME_PLAYERS_PDF": "Εκτύπωση PDF αθλητών",
	"PRINT": "Εκτυπώσεις",
	"GAME_LOGOUT": "Έξοδος από αγώνα",
	"LIMBS": "Limbs",
	"RISER": "Riser",
	"ARROWS": "Βέλη",
	"EQUIPMENT": "Εξοπλισμός",
	"FROM": "από",
	"POSITION": "Θέση",
	"ADD_SHOTS_TO_GAME": "Προσθήκη βολών στον αγώνα",
	"HOST": "Διοργανωτής",
	"SEARCH_GAME_NAME": "Αναζήτηση αγώνα με όνομα",
	"SORT_LEAGUE_NAME": "Συντομογραφία",
	"SEARCH_LEAGUE_NAME": "Αναζήτηση κατηγορίας με όνομα",
	"ADD_PLAYERS_TO_TEAM": "Προσθήλη αθλητών στον σύλλογο",
	"PLAYER": "Αθλητή",
	"USERNAME": "Username",
	"PASSWORD": "Κωδικός",
	"SEARCH_TEAM_NAME": "Αναζήτηση συλλόγου με όνομα",
	"PROFILE": "Προφίλ",
	"LIST_PLAYERS": "Αναζήτηση αθλητή",
	"LIST_TEAMS": "Αναζήτηση συλλόγου",
	"LIST_GAMES": "Αναζήτηση αγώνα",
	"LIST_LEAGUES": "Αναζήτηση κατηγορίας",
	"INDEX": "Αρχική Σελίδα",
	"C": "Γ",
	"SUBMIT": "Υποβολή",
	"SUBMIT_NEXT": "Υποβολή και επόμενος στόχος",
	"SUBMIT_EXIT": "Υποβολή και έξοδος",
	"ERROR_MONKEYS": "Πρόβλημα, έχουμε βάλει τις μαίμουδες μας και δουλέυουν σκληρά να το λύσουν.",
	"SUCCESS": "Επιτυχία",
	"EXISTS": "Υπάρχει ήδη",
	"ROUND_1": "Γύρος 1ος",
	"ROUND_2": "Γύρος 2ος",
	"PLAYERS": "Αθλητές",
	"ADD_PLAYER": "Προσθήκη νέου αθλητή",
	"EDIT_PLAYER": "Επεξεργασία αθλητή",
	"DELETE_PLAYER": "Διαγραφή αθλητή",
	"TEAMS": "Συλλόγοι",
	"ADD_TEAM": "Προσθήκη συλλόγου",
	"EDIT_TEAM": "Επεξεργασία συλλόγου",
	"DELETE_TEAM": "Διαγραφή συλλόγου",
	"GAME": "Αγώνας",
	"ADD_GAME": "Προσθήκη αγώνα",
	"EDIT_GAME_LEAGUES": "Επεξεργασία κατηγοριών παιχνιδιού",
	"EDIT_GAME": "Επεξεργασία Αγώνα",
	"DELETE_GAME": "Διαγραφή Αγώνα",
	"ADD_PLAYERS_TO_MATCH": "Δηλωση αθλητων σε αγωνα",
	"REMOVE_PLAYERS_FROM_MATCH": "Αφαίρεση παιχτών απο αγώνα",
	"ADD_SHOTS_P1": "Προσθήκη βολών",
	"ADD_SHOTS_P2": "Προσθήκη βολών (Τρόπος 2)",
	"ADD_SHOTS_P3": "Προσθήκη βολών (Τρόπος 3)",
	"UPDATE_GAME": "Ενημέρωση Παιχνιδιού",
	"ADD_LEAGUE": "Προσθήκη Κατηγορίας",
	"REMOVE_LEAGUE": "Αφαίρεση Κατηγορίας",
	"DELETE_LEAGUE": "Διαγραφή Κατηγορίας",
	"STATS": "Στατιστικά",
	"GAME_STATS": "Στατιστικά Παιχνιδιού",
	"STATS_FOR_TEAM": "Στατιστικά συλλόγου",
	"STATS_FOR_PLAYER": "Στατιστικά αθλητών",
	"LIVESCORES": "Αποτελέσματα",
	"MENU_SETTINGS": "Ρυθμίσεις Μενού",
	"OVERVIEW": "Γενική όψη Παιχνιδιού",
	"OLYMPIC": "Ολυμπιακός Γύρος",
	"ADD_OLYMPIC_SHOTS": "Προσθήκη βολών Ολ/γύρου",
	"EDIT_GAME_LEAGUES_PLAYERS": "Επεξεργασία κατηγοριών παιχνιδιού για τους παίχτες",
	"PICK_LEAGUE_DEL": "Επιλογή κατηγορίας για διαγραφή",
	"PICK_LEAGUE_ADD": "Επιλογή κατηγορίας για προσθήκη",
	"TRUELIVE_ALL": "ΑΠΟΤΕΛΕΣΜΑΤΑ LIVE (ΟΛΕΣ ΚΑΤΗΓΟΡΙΕΣ)",
	"TRUELIVE_CAT": "ΑΠΟΤΕΛΕΣΜΑΤΑ LIVE (ΕΠΙΛΕΞΤΕ ΚΑΤΗΓΟΡΙΕΣ)",
	"PRINT_GAME_PDF_MEDALS": "Εκτύπωση PDF μεταλίων του αγώνα",
	"PRINT_GAME_PDF_MEDALS_OLYMPIC": "Εκτύπωση PDF μεταλίων του αγώνα με Ολυμπιακό Γύρο",
	"SELECT_ALL": "Επιλογή Όλων",
	"CHECK_THIS_FOR_ALL": "Επιλέξτε αυτό για όλες τις κατηγορίες",
	"GO_BACK": "Επιστροφή πίσω",
	"FXs": "Σύνολο Χ",
	"ROUNDS": "Γύροι",
	"FINAL_SCORES": "Τελικά Σκορ",
	"PLAYER/ER": "Αθηλητής/τρια",
	"O/I": "Ο/η",
	"EMPTY_SHOTS": "έχει κενές βολές στον στόχο ",
	"PRINT_GAME_DETAILS": "Εκτύπωση λεπτομεριών παιχνιδιού",
	"NUMBER": "Νο",
	"PRINT_GAME_PLAYERS": "Εκτύπωση όλων των παιχτών / αλφαβητικη λίστα",
	"ALPHA_LIST_GAME": "Αλφαβητική Λίστα Με Στόχους",
	"PRINT_GAME_TARGETS": "Εκτύπωση όλων των στόχων",
	"ALL_TARGETS": "Λίστα βάση στόχων",
	"PRINT_GAME_PLAYERS_TEAMS": "Εκτύπωση όλων των παιχτών / αλφαβητικη λίστα συλλόγων",
	"MONEY_CHECK": "Έλεγχος",
	"LIST_BY_TEAM": "Λίστα αθλητών ανα συλλόγο",
	"PDF_RIGHTS": "*Προσοχή, τα στοιχεία σε αυτό το έντυπο μπορεί να διαφέρουν απο τα πραγματικά του αγώνα. Σε καμία περίπτωση αυτό το έντυπο δεν αντιπροσωπέυει την ΕΟΤ.",
	"GREEK": "Ελληνικά",
	"GAME_RESULTS": "Προσωπικά Αποτελέσματα Αγώνα",
	"MRS": "Αγαπητέ κύριε/κυρία",
	"HERE_ARE": "Σας αποστέλνουμε τα αποτελέσματα στον αγώνα που συμμετειχατε ",
	"HERE_ARE_TEAM": "Σας αποστέλνουμε τα αποτελέσματα στον αγώνα που συμμετειχε το σωματείο σας ",
	"CUSTOM": "Custom",
	"ARROW_NOW": "Αρ. Βελών",
	"SETTINGS": "Ρυθμίσεις",
	"DEGREE_SETTINGS": "Ρυθμίσεις επαίνων",
	"FIELD_1": "Πεδίο 1",
	"FIELD_2": "Πεδίο 2",
	"FIELD_3": "Πεδίο 3",
	"PRINT_DEGREES": "Εκτύπωση επαίνων",
	"PRINT_DEGREES_QUALIFICATION": "Εκτύπωση επαίνων Ατομικό (Βάση Κατάταξης)",
	"PRINT_DEGREES_OL_TEAM": "Εκτύπωση επαίνων Ομαδικό (Βάση Ολ/Γύρων)",
	"PRINT_DEGREES_QUAL_TEAM": "Εκτύπωση επαίνων Ομαδικό (Βάση Κατάταξης)",
	"PRINT_DEGREES_INDIVIDUAL": "Εκτύπωση επαίνων Ατομικό (Βάση Ολ/Γύρων)",
	"PRINT_DEGREES_OL_MIXED": "Εκτύπωση επαίνων Μικτό Ομαδικό (Βάση Ολ/Γύρων)",
	"PRINT_DEGREES_QUAL_MIXED": "Εκτύπωση επαίνων Μικτό Ομαδικό (Βάση Κατάταξης)",
	"DEGREE_TEXT": "Πεδίο στον έπαινο",
	"NO_FOR_OLYMPIC": "Αριθμός ατόμων για ολυμπιακό γύρο",
	"SUGGESTED": "προτεινομενο",
	"THERE_ARE_TOTAL": "Υπάρχουν συνολικά ",
	"EXPORT_GAME": "Εξαγωγή παιχνιδιού",
	"ONE_PLAYER": "Ενός αθλητή",
	"ALL_PLAYERS": "Όλων των αθλητών",
	"ADD_WITH_FILE": "Προσθήκη με αρχείο",
	"ADD_WITH_DETAILS": "Προσθήκη με λεπτομέριες",
	"ADD_WITHOUT_DETAILS": "Προσθήκη χωρίς λεπτομέριες",
	"IMPORT_GAME": "Εισαγωγή Αγώνα",
	"DEGREE_TEXT_2": "Πεδίο στο έπαινο 2",
	"TEAM_SORT_NAME": "Συντομογραφία Ονόματος",
	"TEAM_S_NAME": "Συν. συλλόγου",
	"SEND_PLAYER_EMAILS": "Αποστολή e-mail παιχτών",
	"ABOUT_ME": "Σχετικά με μένα",
	"INFO": "Πληροφορίες",
	"FOR": "για",
	"BIRTHDATE": "Ημερομηνία Γέννησης",
	"GAME_HISTORY": "Ιστορικό παιχνιδίων",
	"SEND_MESSAGE": "Αποστολή Μηνύματος",
	"FILE_EXPLORER": "Αρχεία",
	"COACH_OF": "προπονητή/τρια του συλλόγου ",
	"RECURVE": "Ολυμπιακό",
	"RECURVE_M_W": "Ολυμπιακό Ανδρών - Γυναικών",
	"RECURVE_YM_YW": "Ολυμπιακό Νέων Ανδρών - Νέων Γυναικών",
	"RECURVE_JM_JW": "Ολυμπιακό Εφήβων - Νεανίδων",
	"COMPOUND": "Σύνθετο",
	"COMPOUND_M_W": "Σύνθετο Ανδρών - Γυναικών",
	"COMPOUND_YM_YW": "Σύνθετο Νέων Ανδρών - Νέων Γυναικών",
	"COMPOUND_JM_JW": "Σύνθετο Εφήβων - Νεανίδων",
	"TEENS": "Εφήβων",
	"NEANIDWN": "Νεανίδων",
	"NO_RESULTS": "Δεν βρέθηκαν αποτελέσματα",
	"INDIVIDUAL_OLYMPIC": "Ατομικό Ολυμπιακό",
	"TEAM_OLYMPIC": "Ομαδικό Ολυμπικό",
	"NO_FOR_OLYMPIC_TEAMS": "Αριθμός ομάδων για ολυμπιακό γύρο",
	"PICK_CATEGORY": "Επιλέξτε κατηγορία",
	"NOT_ENOUGH_PLAYERS": "Ο συλλόγος δεν έχει αρκετούς αθλητες ώστε να συμμετάσχει στον ολυμπιακό γύρο",
	"PLAYER_1": "Αθλητής 1",
	"PLAYER_2": "Αθλητής 2",
	"PLAYER_3": "Αθλητής 3",
	"MIXED_TEAM_OLYMPIC": "Μικτό Ομαδικό Ολυμπικό",
	"OL_TEAM": "Ομαδικό",
	"FINAL": "Τελικός",
	"PRINT_GAME_BOOK": "Εκτύπωση βιβλίου αγώνα",
	"MEDALS_FROM_QUALIFICATIONS": "Μετάλια βάση κατάταξης",
	"MEDALS_FROM_OLYMPIC": "Μετάλια βάση ολυμπιακού γύρου",
	"MEDAL": "Μετάλιο",
	"GOLD": "Χρυσό",
	"SILVER": "Αργυρό",
	"BRONZE": "Χάλκινο",
	"ENTRIES_BY_TEAM": "Συμμετοχές Ανα Συλλογο",
	"OLYMPIC_ROUNDS_INDIVIDUAL": "Ολυμπιακοί Γύροι Ατομικό",
	"QUALIFICATION_INDIVIDUAL": "Κατάταξη Ατομικό",
	"OLYMPIC_ROUNDS_TEAM": "Ολυμπιακοί Γύροι Ομαδικό",
	"QUALIFICATION_TEAM": "Κατάταξη Ομαδικό",
	"MIXED_TEAM": "Μικτό Ομαδικό",
	"INDIVIDUAL": "Ατομικό",
	"PRINT_OLYMPIC_ROUNDS": "Εκτύπωση Ολυμπιακών Γύρων",
	"MIXED": "Μικτό",
	"ADD_GAME_QUICKSTART": "Προσθήκη Αγώνα (Γρήγορο)",
	"TYPE": "Τύπος",
	"DATE_FILED": "Ημερομηνία κατάθεσης",
	"GGA_NUMBER": "Αριθμός ΓΓΑ",
	"LEVEL": "Level προπονητή",
	"COACH_LEVEL": "Level προπονητή",
	"JUDGE_LEVEL": "Level κριτή",
	"TRAINER_LEVEL": "Level εκπαιδευτή",
	"COACH_0_LEVEL": "ΠΡΟΠΟΝΗΤΗΣ",
	"COACH_A_LEVEL": "Α’ ΚΑΤΗΓΟΡΙΑΣ",
	"COACH_B_LEVEL": "Β’ ΚΑΤΗΓΟΡΙΑΣ",
	"COACH_C_LEVEL": "Γ’ ΚΑΤΗΓΟΡΙΑΣ",
	"TRAINER_0_LEVEL": "ΕΚΠΑΙΔΕΥΤΗΣ",
	"TRAINER_1_LEVEL": "LEVEL 1",
	"TRAINER_2_LEVEL": "LEVEL 2",
	"TRAINER_3_LEVEL": "LEVEL 3",
	"CL1": "CL1",
	"CL2": "CL2",
	"SELECT_LEVEL": "Επιλέξτε level",
	"JUDGE_STAFF": "ΔΙΟΙΚΗΣΗ",
	"JUDGE_INTERNATIONAL": "ΔΙΕΘΝΗΣ",
	"JUDGE_NATIONAL": "ΕΘΝΙΚΟΣ",
	"JUDGE_CANDIDATE": "ΔΟΚΙΜΟΣ",
	"INDOOR": "Εσωτερικού Χώρου",
	"OUTDOOR": "Εξωτερικού Χώρου",
	"indoor": "Εσωτερικού Χώρου",
	"outdoor": "Εξωτερικού Χώρου",
	"GAME_TYPE": "Τύπος Αγώνα",
	"GAME_DETAILS": "Λεπτομέριες Αγώνα",
	"GAME_LEAGUES": "Κατηγορίες Αγώνα",
	"GREAT": "Τέλεια",
	"PREVIOUS": "Προηγούμενο",
	"NEXT": "Επόμενο",
	"BIRTH_PLACE": "Τόπος Γεννήσεως",
	"STATE": "Νομός",
	"CITIZENSHIP": "Υπήκοότητα",
	"NATIONALITY": "Εθνικότητα",
	"EXPATRIATE": "Ομογενής",
	"CITY": "Πόλη",
	"ADT": "Αριθμός Δελτίου Ταυτότητας",
	"PASSPORT": "Διαβατήριο",
	"HEALTH": "Αριθμός Δελτίου Υγείας",
	"AMEA": "Para-Archery",
	"A_TARGET": "Τριπλέτα",
	"REGISTRATION_DATE": "Ημερομηνία Εγγραφής",
	"FULL_NAME": "Πλήρες όνομα",
	"NAME": "Όνομα",
	"IDENTIFY_DATE": "Ημερομηνία Αναγνώρισης",
	"IDENTIFY_CODE": "Κωδικός Αναγνώρισης",
	"COUNTY": "Δήμος",
	"FAX": "FAX",
	"WEB": "Ιστοσελίδα",
	"AFM": "Α.Φ.Μ.",
	"DOY": "Δ.Ο.Υ.",
	"COACH_EMAIL": "E-mail Προπονητή",
	"REGION": "Περιοχή",
	"CALENDAR": "Ημερολόγιο",
	"REG_DATE": "Ημ/ Εγγραφής",
	"LNAME": "Όνομα",
	"FNAME": "Επώνυμο",
	"STATUS": "Κατάσταση",
	"DETAILS": "Λεπτομέριες",
	"CLEAR_SHOTS": "Καθαρισμός Βολών",
	"SUBMIT_RETURN": "Υποβολή και επιστροφή",
	"QUALIFICATION_MIXED_TEAM": "Κατάταξη Μικτό Ομαδικό",
	"OLYMPIC_TEAM_MIXED": "Ολυμπιακοί Γύροι Μικτό Ομαδικό",
	"EMPTY_ALL_TARGETS": "Καθαρισμός Στόχων",
	"PRINT_OLMPIC_LAYOUT": "Olympic Rounds Layout",
	"PRODUCE_TARGETS": "Παραγωγή Στόχων",
	"TARGETS_NUMBER": "Αριθμός Διαθέσιμων Στόχων",
	"CHOOSE_PLAYERS": "Επιλογή Παιχτών",
	"VIEW_REGISTRATION": "Προβολή τρέχουσας δήλωσης",
	"LIST_ENTRIES": "Λίστα συμμετέχωντων",
	"DELETE": "Διαγραφή",
	"HOW_MANY": "Πόσες εισόδους?",
	"REGISTRATION_OPEN_DATE": "Έναρξη δηλώσεων συμμετοχής",
	"REGISTRATION_END_DATE": "Τέλος δηλώσεων συμμετοχής",
	"CLOSE_REGISTRATION": "Λήξη δηλώσεων σημμετοχών",
	"PRINT_ENTRIES_PDF": "Εκτύπωση PDF συμμετοχών",
	"PRINT_ENTRIES_PDF_SPECIFIC": "Εκτύπωση PDF συμμετοχών ( Ομάδας )",
	"GAME_ENTRIES": "Δήλωση συμμετοχών",
	"NOTES": "Σημειώσεις",
	"TARGETS": "Στόχοι",
	"TARGET": "Στόχος",
	"PLAYER_LEAGUES": "Κατηγορίες αθλητών",
	"ADD_SHOTS_OLYMPIC": "Προσθήκη βολών Ολ/ γύρων",
	"ADD_PLAYERS": "Προσθήκη αθλητών",
	"REMOVE_PLAYERS": "Αφαίρεση αθλητών",
	"PLAYERS_REGISTERD": "Δηλώσεις Συμμετοχής Αθλητών",
	"EDIT_PERMISSIONS": "Επεξεργασία δικαιωμάτων",
	"USER_ROLE": "Ρόλος",
	"EDIT_ROLES": "Επεξεργασία ρόλων",
	"CLOSED": "ΚΛΕΙΣΤΗ",
	"OPEN": "ΑΝΟΙΧΤΗ",
	"REGISTRATION_STATUS": "Η δήλωση συμμετοχών είναι ",
	"REGISTRAION_CLOSED_TEXT": "** Η δήλωση συμμετοχών είναι κλειστή. Δεν μπορείτε να πραγματοποιήσετε αλλαγές. Παρακαλούμε επικοινωνήστε μαζί μας στο info@archery.org.gr για οποιαδήποτε απορία έχετε.",
	"CURRENT_LIST": "Τρέχων δήλσωη",
	"ENTRIES_PDF": "Εκτύπωση δήλωσης",
	"REGISTRATION_CLOSED_TEXT_LIST": "**Παρακάτω είναι η λίστα με τους αθλητές που έχετε δηλώσει. Η δήλωση συμμετοχών είναι κλειστή. Δεν μπορείτε να πραγματοποιήσετε αλλαγές. Παρακαλούμε επικοινωνήστε μαζί μας στο info@archery.org.gr για οποιαδήποτε απορία έχετε.",
	"ENTRIES_PROOF": "** Παρακαλούμε εκτυπώστε και κρατήστε το αρχέιο με την λίστα αθλητών σας σαν απόδειξη",
	"GRATZ_TO": "Συγχαρητήρια στον/ην",
	"COMPETED_IN": "που αγωνίστηκε στην κατηγορία",
	"NOW_ELIGIBLE": "μπορεί πλέον να αγωνηστεί στην κατηγορία",
	"AFTER_SCOREING": "αφού έφερε σύνολο",
	"PASSED_LIMIT": "και πέρασε το όριο",
	"COMPANION": "Συνοδός",
	"SAVE_MATCH_TEAM_INFO": "ΑΠΟΘΗΚΕΥΣΗ ΣΥΝΟΔΩΝ",
	"CAPTAIN": "Αρχηγός",
	"REQUIRED_FIELDS": "Τα πεδία με * είναι υποχρεωτικά",
	"PLUGINS": "Plugins",
	"VALIDATE_PASSPORTS": "Επικύρωση Δελτίων (Τρέχων Ετος)",
	"VALIDATE_PASSPORT": "Επικύρωση Δελτίου Αθλητή (Τρέχων Ετος)",
	"FINANCIAL": "Χρηματοοικονομικά",
	"ADD_PAYMENT_REASON": "Προσθήκη Υπηρεσίας/Είδος",
	"PRICE": "Ποσό",
	"COMMENTS": "Σχόλια",
	"ADD_PAYMENT_TEAM": "Πληρωμές Συλλόγων",
	"ADD_PAYMENT_PLAYER": "Πληρωμές Αθλητών",
	"PAYMENT_REASON": "Περιγραφή Κίνησης",
	"ADD_PAYMENT": "Προσθήκη Πληρωμής",
	"REQUIRED_TEAM": "Απαιτούμενο για την συμμετοχή συλλόγου σε αγώνα",
	"REQUIRED_PLAYER": "Απαιτούμενο για την συμμετοχή αθλητών σε αγώνα",
	"YEAR": "Χρονιά",
	"ADD_NEW": "Προσθήκη Νέου",
	"EDIT_USERS": "Επεξεργασία Χρηστών",
	"PAYMENT_REPORT": "Καρτέλα Πληρωμών",
	"REPORT_OF_YEAR": "Καρτέλα πληρωμών έτους : ",
	"AMOUNT_PAID": "Ποσό κατάθεσης",
	"MOVEMENT_REPORT": "Καρτέλα κινήσεων",
	"TEAM_REPORT_NAME": "Επωνυμία : ",
	"TOTAL_MOVEMENTS": "Σύνολο Κινήσεων : ",
	"TOTAL_AMOUNT_MOVED": "Συνολικο ποσό : ",
	"PAYMENT_DATE": "Ημερομηνία Κίνησης",
	"STARTED_DATE": "Ώρα Εισόδου",
	"ENDED_DATE": "Ώρα Εξόδου",
	"CANCEL": "Άκυρο",
	"PAYMENT_SUCCESSFULL": "Ολοκληρώθηκε επιτυχώς",
	"PAYMENT_FAILED": "Δεν ολοκληρώθηκε η πληρωμή",
	"LIST_PAYMENT_MOVEMENTS_TEAMS": "Λίστα κινήσεων συλλόγων",
	"LIST_PAYMENT_MOVEMENTS_PLAYERS": "Λίστα κινήσεων αθλητών",
	"EDIT_PAYMENT": "Επεξεργασία Κίνησης",
	"CANCEL_PAYMENT": "Ακύρωση κίνησης",
	"PAYMENT_EDIT_SUCCESSFULL": "Η επεξεργασία ολοκληρώθηκε επιτυχώς",
	"PAYMENT_EDIT_FAIL": "Δεν ολοκληρώθηκε η επεξεργασία",
	"IMPORT_SCORES": "Εισαγωγή Σκόρ Απο Αρχείο",
	"PLAYER_PASSPORT": "Δελτίο Αθλητή",
	"VALID": "Έγκυρο",
	"NOT_VALID": "Μή έγκυρο",
	"PAID": "Πληρώθηκε",
	"NOT_PAID": "Δεν έχει πληρωθεί",
	"STUDENT": "Μαθητής",
	"STUDENT_TEAM": "Σχολική Ομάδα",
	"NATIONAL": "Εθνική",
	"NATIONAL_TEAM": "Εθνική Ομάδα",
	"AMEA_TEAM": "Ομάδα Α.Μ.Ε.Α",
	"TRANSFERS": "Μεταγραφές",
	"TRANSFER": "Μεταγραφή",
	"FROM_TEAM": "Από ",
	"TO_TEAM": "Σε ",
	"OLD_HEALTH": "Παλιό Δελτίο Υγείας",
	"NEW_HEALTH": "Καινούργιο Δελτίο Υγείας",
	"TRANSFER_SUCCESSFUL": "Η μεταγραφή ολοκληρώθηκε με επιτυχία",
	"TRANSFER_FAIL": "Η μεταγραφή δεν ολοκληρώθηκε",
	"NEW_TRANSFER": "Νέα Μεταγραφή",
	"ALREADY_PAID": "ΕΧΕΙ ΠΛΗΡΩΘΕΙ",
	"ALREADY_EXISTS": "ΥΠΑΡΧΕΙ ΗΔΗ",
	"FROM_TO_EMPTY_FOR_ALL": "Από - Μεχρι",
	"PAYMENT_REASON_EMPTY_FOR_ALL": "Λόγος πληρωμής ( Κενό για όλους )",
	"PICK_TEAM_EMPTY_FOR_ALL": "Επιλογή Συλλόγου ( Κενό για όλους )",
	"PICK_PLAYER_EMPTY_FOR_ALL": "Επιλογή Αθλητή ( Κενό για όλους )",
	"RESTORE_PAYMENT": "Επαναφορά Κίνησης",
	"PLAYER_ADDED_SUCCESSFUL_CODE": "Ο αθλητής προστέθηκε επιτυχώς. Ο αριθμός αναγνώρισης του είναι ",
	"PLAYER_ADDED_SUCCESSFUL": "Ο αθλητής προστέθηκε επιτυχώς.",
	"PLEASE_FILL_ALL_FIELDS": "Παρακαλούμε συμπληρώστε όλα τα πεδία με *",
	"PLAYER_NOT_ADDED": "Ο αθλητής δεν προστέθηκε. Παρακαλούμε προσπαθήστε ξανά",
	"SAME_PLAYER_DETECTED": "Εντοπίστηκε αθλητής με τα ίδια στοιχεία. Θέλετε να συνεχίσετε με την καταχώρυση ?",
	"PLEASE_FILL_FNAME": "Παρακαλούμε συμπληρώστε όνομα.",
	"PLEASE_FILL_LNAME": "Παρακαλούμε συμπληρώστε επώνυμο.",
	"PLEASE_FILL_TEAM": "Παρακαλούμε συμπληρώστε ομάδα.",
	"PLEASE_FILL_SEX": "Παρακαλούμε συμπληρώστε το φύλο.",
	"PLEASE_FILL_STATE": "Παρακαλούμε συμπληρώστε τον νομό.",
	"PLEASE_FILL_CITIZENSHIP": "Παρακαλούμε συμπληρώστε την υπηκοότητα.",
	"PLEASE_FILL_NATIONALITY": "Παρακαλούμε συμπληρώστε την εθνικότητα.",
	"LIST_TRANSFERS": "Λίστα Μεταγραφών",
	"TRANSFER_DATE": "Ημερομηνία Μεταγραφής",
	"EDIT_TARGETS": "Επεξεργασία στόχων",
	"TOTAL_ENTRIES": "Συνολικές Συμμετοχές",
	"UNIQUE_ENTRIES": "Μοναδικές Συμμετοχές",
	"PDF": "Εκτύπωση",
	"MATCH_OVERVIEW": "Match Overview",
	"OFFICIAL_SCORE": "Official σκορ",
	"ENTRIES": "Συμμετοχές",
	"REMOVED_PLAYER_FROM_YEAR": "Ακυρώθηκε η επικύρωση δελτίου του αθλητή για το έτος ",
	"RECEIVED_CARD": "Παραλαβή Κάρτας ( Τρέχων Έτος )",
	"FORFEITED": "Εγκατέλειψε / Δεν Προσήλθε",
	"TEAM_INFO": "Στοιχεία Ομάδας",
	"MOVE_GAME": "Μεταφορά Αγώνα",
	"MOVE_FRONT": "Μετακίνηση προς τα εμπρός",
	"MOVE_TARGETS": "Μετακίνηση στόχων",
	"DISTANCE": "Απόσταση",
	"FROM_TARGET": "Απο στόχο",
	"TO_TARGET": "Εώς στόχο",
	"MOVE_BACK": "Μετακίνηση προς τα πίσω",
	"TOTAL_PLAYERS": "Σύνολο Αθλητών",
	"TOP_SCORE_IN_LEAGUE": "Επίδοση",
	"TOTAL_ENTRIES_IN_LEAGUE": "Συμμετοχές",
	"AMS_CODE": "Κωδικός",
	"EOT": "ΕΛΛΗΝΙΚΗ ΟΜΟΣΠΟΝΔΙΑ ΤΟΞΟΒΟΛΙΑΣ",
	"REPORT_1": "Μητρώο Σωματείων",
	"REPORT_2": "Μητρώο Αθλητών/Σωματείο",
	"REPORT_3": "Εγγεγραμμένοι αθλητές / Σωματείο",
	"REPORT_4": "Διοργανώσεις και Συμμετοχές ",
	"REPORT_5": "Συμμετοχές Αθλητών ανά αγώνισμα και ηλικιακή κατηγορία",
	"REPORT_6": "Συμμετοχές Αθλητών ανά Σωματείο",
	"REPORT_7": "Επίδοσεις Αθλητών ανά Σωματείο, Κατηγορία Αγωνίσματος & Ηλικίας",
	"REPORT_8": "Λίστα Πολυνικών Αθλητών & Σωματείων",
	"REPORT_9": "Λίστα εισόδων προπονητήριο",
	"REPORT_10": "Καλύτερη Επίδοση Αθλητών ανά Σωματείο, Κατηγορία Αγωνίσματος & Ηλικίας",
	"REPORT_11": "Μητρώο Αθλητών (ΓΓΑ)",
	"REPORT_12": "Μητρώο Συλλόγων (ΓΓΑ)",
	"FOR_YEAR": "Για το έτος",
	"RECURVE_COMPOUND_POINTS": "ΓΕΝΙΚΗ ΒΑΘΜΟΛΟΓΙΑ ΣΥΛΛΟΓΩΝ ΕΤΟΥΣ ",
	"RECURVE_POINTS": "ΟΛΥΜΠΙΑΚΟ ΤΟΞΟ (RECURVE) ΣΥΛΛΟΓΟΙ",
	"COMPOUND_POINTS": "ΣΥΝΘΕΤΟ ΤΟΞΟ (COMPOUND) ΣΥΛΛΟΓΟΙ",
	"POINTS": "ΠΟΝΤΟΙ",
	"SUSPEND_REASON": "Λόγος",
	"SUSPEND_TEAM": "Suspend Σωματείο",
	"TEAM_IS_SUSPENDED": "Δεν μπορείτε να δηλώσετε αθλητές αυτή τη στιγμή.",
	"TEAM_IS_SUSPENDED_PROFILE": "Το σωματείο είναι suspended.",
	"OVERRIDE_AGE_LIMITS": "Override Age Limits",
	"PLAYER_MATCHES": "Αγώνες Αθλητή",
	"PLAYER_PAYMENTS": "Πληρωμές Αθλητή",
	"PASSPORTS": "Δελτία",
	"START_DATE": "Ημερομηνία Έναρξης",
	"DAYS_LEFT": "Μέρες που απομένουν",
	"VALID_UNTIL": "Ισχύει Μέχρι",
	"DAYS": "μέρες",
	"EXPIRED": "Έχει λήξει",
	"ADD_PASSPORT": "Προσθήκη Δελτίου",
	"LIMIT_INDOOR": "Όριο Κλειστού Χώρου",
	"LIMIT_OUTDOOR": "Όριο Ανοιχτού Χώρου",
	"OVERRIDE_LIMITS": "Override Limits ( Age & Score )",
	"OVERRIDE_CHECKS": "Override All Check",
	"MATCH_CODE": "Κωδικός Αγώνα",
	"PLAYER_NAME": "Όνομα αθλητή",
	"FIRST_NAME": "Όνομα",
	"LAST_NAME": "Επώνυμο",
	"SEX": "Φύλο",
	"MEN": "Άντρας",
	"WOMEN": "Γυναίκα",
	"OTHER": "Άλλο",
	"EMAIL": "E-mail",
	"BIRTH": "Ημερομηνία Γέννησης",
	"LEAGUE": "Κατηγορία",
	"TEAM": "Σύλλογος",
	"EDIT": "Επεξεργασία",
	"PICK_PLAYER": "Επιλογή αθλητή",
	"FATHER_NAME": "Όνομα Πατέρα",
	"MOTHER_NAME": "Όνομα Μητέρας",
	"CODE": "Αρ. Μητρώου",
	"TEAM_NAME": "Όνομα συλλόγου",
	"LOCATION": "Τοποθεσία",
	"PICK_TEAM": "Επιλογή συλλόγου",
	"ADDRESS": "Διεύθυνση",
	"EFOT_REG": "Κωδικός Ε.Ο.Τ.",
	"PC": "Ταχ. Κώδικας",
	"ADMIN": "Διαχειριστής",
	"COACH": "Προπονητής",
	"PHONE": "Τηλέφωνο",
	"TARGET_FROM": "Στόχοι από",
	"TARGET_TO": "εώς",
	"GAME_NAME": "Όνομα Αγώνα",
	"DATE": "Ημερομηνία",
	"LEAGUES": "Κατηγορίες",
	"PICK_GAME": "Επιλογή Αγώνα",
	"TARGET_NAME": "Στόχος",
	"ROUND": "Γύρος",
	"PICK_TARGET": "Επιλέξτε στόχο",
	"SHOT_1": "Βολή 1",
	"SHOT_2": "Βολή 2",
	"SHOT_3": "Βολή 3",
	"SHOT_4": "Βολή 4",
	"SHOT_5": "Βολή 5",
	"SHOT_6": "Βολή 6",
	"SHOT_7": "Βολή 7",
	"SHOT_8": "Βολή 8",
	"SHOT_9": "Βολή 9",
	"SHOT_10": "Βολή 10",
	"UPDATE_ROUND_1": "Ενημέρωση Γύρου 1",
	"UPDATE_ROUND_2": "Ενημέρωση Γύρου 2",
	"ARE_YOU_SURE_UPDATE_GAME": "Είστε σίγουρος ότι θέλετε να ενημερώσετε τον αγώνα?",
	"INFO_GAME": "Πληροφορίες Αγώνα",
	"JUDGE": "Κριτές",
	"REPRESENTER": "Εκπρόσωποι της ΕΟΤ",
	"COMMITTEE": "Αγωνόδικος Επιτροπή",
	"SWAP_PLAYERS": "Εναλλαγή παιχτών",
	"MOVE_PLAYER": "Μετακίνηση σε στόχο",
	"SWAP_TARGETS": "Εναλλαγή στόχων",
	"ORDER_BY": "Ταξινόμιση ανά",
	"SEARCH_NAME": "Αναζήτηση με όνομα αθλητή",
	"SEARCH_TEAM": "Αναζήτηση με συλλόγο",
	"PICK_ROUND": "Επιλογή Γύρου",
	"ARROW": "Βέλος",
	"LEAGUE_NAME": "Όνομα Κατηγορίας",
	"CATEGORY": "Κατηγορία",
	"CATEGORY_S": "Κατ.",
	"PICK_LEAGUE": "Επιλογή Κατηγορίας",
	"TOTAL_SCORE": "Συνολικό Σκόρ",
	"SHOT_NOW": "Αρ. Βολής",
	"TOTAL": "Σύνολο",
	"TOTAL/RANK": "Σύνολο/ Κατ",
	"TOTAL/RANKs": "Συνολ. Επίδοση",
	"TOTAL_SCORE_POINTS": "Πόντοι",
	"REAL_LIVESCORES": "Livescores",
	"SHOT_NUMBER_NOW": "Βολή τώρα",
	"SHOT_SCORE_SO_FAR": "Σκορ εώς τώρα",
	"RANK": "Κατ.",
	"ROUND_1/RANK": "Γύρος 1/ Κατ",
	"ROUND_2/RANK": "Γύρος 2/ Κατ",
	"ROUND_1/RANKs": "Γ.1",
	"ROUND_2/RANKs": "Γ.2",
	"10s": "10ρια",
	"9s": "9ρια",
	"10ss": "10",
	"9ss": "9",
	"INCREMENT_SCORE": "Προοδευτικό Σκορ",
	"FINAL_SCORE": "Τελικό Σκόρ",
	"SHOT_SCORE": "Σκόρ Βολής",
	"F10s": "Σύνολο 10ρια",
	"F9s": "Σύνολο 9ρια",
	"STOP_AUTOSCROLLING": "Stop Autoscrolling",
	"TOP_2_PLAYERS": "Καλύτεροι 2 παίχτες ανα κατηγορία",
	"START_AUTOSCREOLLING": "Start Autoscrolling",
	"MATCH_DATE": "Ημερομηνία Αγώνα",
	"DOWNLOAD_RESULTS": "Κατέβασμα αποτελεσμάτων PDF",
	"UPLOAD_RESULTS_PDF": "Ανέβασμα PDF αποτελεσμάτων",
	"CURRENT_RESULTS_PDF": "Τωρινό ανεβασμένο PDF",
	"IMPORT_OLD_GAMES": "Ανέβασμα παλαιότερων αγώνων",
	"EXTENSION_ERROR": "Δεν επιτρεπεται ο συγκεκριμενος τυπος αρχείου.",
	"PHOTO_SIZE_ERROR": "Φωτογραφίες μέχρι 2ΜΒ σε μέγεθος",
	"UNKNOWN": "Πρόβλημα στο ανέβασμα της φωτογραφίας.",
	"UPLOAD_FAILED": "Πρόβλημα στο ανέβασμα της φωτογραφίας.",
	"NO_IMAGE": "Επιλέξτε μια εικόνα πρώτα.",
	"ALL_ATHLETES": "Όλοι οι αθλητές",
	"ACTIVE_ATHLETES": "Ενεργοί αθλητές"
};


//////////////////
// WEBPACK FOOTER
// ./client/app/translations/el.json
// module id = 1084
// module chunks = 0